// extracted by mini-css-extract-plugin
export default {"hoverGroupV":"VehicleStyling_hoverGroupV__PSppP","buttonForDelete":"VehicleStyling_buttonForDelete__yd1Kz"};